import { DownOutlined } from '@ant-design/icons';
import { Flex } from 'antd';


export const ScrollPrompt = () => (
    <Flex align='center' justify='center' vertical>
        <DownOutlined className='scroll-prompt'/>
    </Flex>
)
